import { cn } from '@folio/index';

interface GarantiePlusLogoProps {
  className?: string;
}

export function GarantiePlusAuthLogo({ className }: GarantiePlusLogoProps) {
  return (
    <img src="/Logo_horizontale.png" alt="Garantie Plus Logo" className={cn('h-auto', className)} />
  );
}
